import React from "react";


const TopHeader = () => {
  return (
    <>
      <style>{`
        .top-info-bar {
          background: #000;
          color: #fff;
          font-size: 14px;
          padding: 8px 0;
        }

        .top-info-container {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
          opacity: 0.9;
        }

        /* ===== LARGE SCREENS ===== */
        @media (min-width: 1400px) {
          .top-info-bar {
            font-size: 12px;
          }
        }

        /* ===== TABLET ===== */
        @media (max-width: 992px) {
          .top-info-container {
            flex-wrap: wrap;
            justify-content: center;
          }
        }

        /* ===== MOBILE ===== */
        @media (max-width: 576px) {
          .top-info-bar {
            font-size: 7px;
          }

          .top-info-container {
            flex-direction: row;
            align-items: center;
            text-align: center;
            gap: 2px;
          }

          .info-item {
            white-space: normal;
          }
        }
      `}</style>
       <div className="top-info-bar">
        <div className="top-info-container">
          <div className="info-item">
            🕒 <span>Sun - Fri: 9:00 AM - 8:00 PM</span>
          </div>

          <div className="info-item">
            ✉️ <span>z1techbhw@gmail.com</span>
          </div>

          <div className="info-item">
            📞 <span>071590132 / 9857050123</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;